import { render } from "./SearchPanel.vue?vue&type=template&id=11c2df87&scoped=true"
const script = {}

import "./SearchPanel.vue?vue&type=style&index=0&id=11c2df87&lang=less&scoped=true"

import exportComponent from "/builds/toyota/bo/merchant-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c2df87"]])

export default __exports__